import React, { ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@fx-ui/fine-design';
import { isString } from '~/utils';
import classNames from 'classnames';
import { IconFont } from '~/components';

interface ITextIconTipProps {
    className?: string;
    text: ReactNode;
    tip?: ReactNode;
    icon?: ReactNode;
    tipWidth?: number | string; // 提示框的宽度，默认200px
    tipPadding?: number;
    gap?: number; // 文本与图标的间距，默认5px
    effect?: TooltipProps['effect'];
    placement?: TooltipProps['placement'];
}

const TextIconTip: React.FC<ITextIconTipProps> = (props) => {
    const {
        className,
        text,
        tip,
        icon = 'help',
        tipWidth = 200,
        tipPadding,
        gap = 4,
        effect = 'light',
        placement = 'top'
    } = props;

    return (
        <div className={classNames('fx-text-icon-tip', className)}>
            <span className="text" style={{ marginRight: tip ? gap : 0 }}>
                {text}
            </span>
            {tip && (
                <Tooltip
                    style={{ width: tipWidth, padding: tipPadding }}
                    effect={effect}
                    content={tip}
                    placement={placement}
                >
                    {isString(icon) ? <IconFont className="tip-icon" type={icon} /> : icon}
                </Tooltip>
            )}
        </div>
    );
};

export default TextIconTip;
